import gql from 'graphql-tag'
import { JOB_FRAGMENT } from '../apollo.fragment'

export const APPLY_JOB_MUTATION = gql`
	mutation CreateJobApplicant($jobId: String!, $note: String) {
		createJobApplicant(jobId: $jobId, note: $note) {
			job {
				...jobFragment
			}
			id
		}
	}
	${JOB_FRAGMENT}
`
